export default function HeroSection({className, ...props}) {

    return (

        <div className={`bg-[#F0F7FF] hidden lg:flex flex-row justify-center items-center   ${className}`}>
            <div className={"w-[70%] flex flex-row"}>
                <div className={"flex flex-1 justify-center flex-col  "}>
                    <p className={"text-[2rem] 2xl:text-[2.5rem] 3xl:text-[3.3125rem] font-poppins font-extrabold text-black"}>
                        Pricing
                    </p>

                </div>
                <img src={"/images/prcingClip.svg"} className={"w-[200px] "} alt={"bg"}/>
            </div>
        </div>

    )
}